import { createIcon } from '@chakra-ui/icons';

export const Calendar = createIcon({
  displayName: 'Calendar',
  viewBox: '0 0 9 9',
  path: [
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1097_24879)">
        <path d="M3.09375 4.125H2.0625V5.15625H3.09375V4.125Z" fill="currentColor" />
        <path d="M4.64062 4.125H3.60938V5.15625H4.64062V4.125Z" fill="currentColor" />
        <path d="M3.09375 5.67188H2.0625V6.70312H3.09375V5.67188Z" fill="currentColor" />
        <path d="M4.64062 5.67188H3.60938V6.70312H4.64062V5.67188Z" fill="currentColor" />
        <path d="M6.1875 4.125H5.15625V5.15625H6.1875V4.125Z" fill="currentColor" />
        <path d="M6.1875 5.67188H5.15625V6.70312H6.1875V5.67188Z" fill="currentColor" />
        <path
          d="M7.21875 1.54688H6.70312V0.515625C6.70312 0.378873 6.6488 0.247722 6.5521 0.151023C6.4554 0.0543246 6.32425 0 6.1875 0C6.05075 0 5.9196 0.0543246 5.8229 0.151023C5.7262 0.247722 5.67188 0.378873 5.67188 0.515625V1.54688H2.57812V0.515625C2.57812 0.378873 2.5238 0.247722 2.4271 0.151023C2.3304 0.0543246 2.19925 0 2.0625 0C1.92575 0 1.7946 0.0543246 1.6979 0.151023C1.6012 0.247722 1.54688 0.378873 1.54688 0.515625V1.54688H1.03125C0.757746 1.54688 0.495443 1.65552 0.302046 1.84892C0.108649 2.04232 0 2.30462 0 2.57812L0 7.21875C0 7.49225 0.108649 7.75456 0.302046 7.94795C0.495443 8.14135 0.757746 8.25 1.03125 8.25H7.21875C7.49225 8.25 7.75456 8.14135 7.94795 7.94795C8.14135 7.75456 8.25 7.49225 8.25 7.21875V2.57812C8.25 2.30462 8.14135 2.04232 7.94795 1.84892C7.75456 1.65552 7.49225 1.54688 7.21875 1.54688ZM7.21875 7.21875H1.03125V3.60938H7.21875V7.21875Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1097_24879">
          <rect width="8.25" height="8.25" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
